import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { adminMe, clearToken, getToken } from "@/lib/admin";

export default function RequireAdmin({ children }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ checking: true, ok: false });

  useEffect(() => {
    let active = true;
    if (!getToken()) {
      setState({ checking: false, ok: false });
      return;
    }
    adminMe()
      .then(() => active && setState({ checking: false, ok: true }))
      .catch(() => {
        clearToken();
        if (active) setState({ checking: false, ok: false });
        navigate("/admin/login", { replace: true });
      });
    return () => {
      active = false;
    };
  }, [navigate]);

  if (state.checking) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-bone text-charcoal text-[0.7rem] tracking-[0.28em] uppercase"
        data-testid="admin-checking-auth"
      >
        Verifying…
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return children;
}
